import React from 'react';
import ReportFrame from '../ReportFrame';

export default class LineItemsAr extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = { Type: 1 };
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          reportName='Line Items AR'
          reportParams={reportParams}
          id='lineitemsar'
          name='lineitemsAR'
          title='Line Items AR'
          hiddenParameters={['Type']}
        />
      </div>
    );
  }
}
